export default "__VITE_ASSET__CpOIgFxN__"